import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

Vue.config.productionTip = false
Vue.use(ElementUI)

// 配置axios
axios.defaults.baseURL = '/api'
//axios.defaults.baseURL = 'http://8.138.170.50:8080/api'



// 请求拦截器 - 添加Token
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// 响应拦截器 - 处理未登录
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      // 清除本地存储
      localStorage.removeItem('token')
      localStorage.removeItem('user_info')
      
      // 只有在非公开页面才跳转到登录页
      const currentPath = router.currentRoute.path
      const publicPaths = ['/', '/login', '/register']
      const isResourceDetail = currentPath.startsWith('/resource/')
      
      // 如果不是公开页面且不是资源详情页，则跳转到登录页
      if (!publicPaths.includes(currentPath) && !isResourceDetail && currentPath !== '/login') {
        router.push('/login')
      }
    }
    return Promise.reject(error)
  }
)

Vue.prototype.$axios = axios

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
